import { __assign, __awaiter, __generator, __spreadArray } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ActionIcon, Button, Group, Table, Text, useMantineTheme, } from "@mantine/core";
import { useEffect, useState } from "react";
import { TbArrowsSort, TbSortAscending2, TbSortDescending2, } from "react-icons/tb";
import PaginationBar from "./PaginationBar";
import TableFilter from "./TableFilter";
var KapexTable = function (props) {
    var theme = useMantineTheme();
    //pageData
    var _a = useState([]), rowData = _a[0], setRowData = _a[1];
    //sorting
    var _b = useState(undefined), sortField = _b[0], setSortField = _b[1];
    var _c = useState("DESC"), sortDirection = _c[0], setSortDirection = _c[1];
    //pagination
    var _d = useState(1), page = _d[0], setPage = _d[1];
    var _e = useState(15), pageSize = _e[0], setPageSize = _e[1];
    var _f = useState(1), rowCount = _f[0], setRowCount = _f[1];
    //filters
    var getInitialFilterParams = function () {
        return (props.columnConfigs
            .filter(function (config) { return config.filter && config.filter.initialValue; })
            .map(function (config) {
            var _a, _b, _c, _d;
            var filterConfig = config.filter;
            var initialValue = {};
            switch (filterConfig.type) {
                case "select":
                    initialValue.values = (_a = filterConfig.initialValue) === null || _a === void 0 ? void 0 : _a.values;
                    break;
                case "date":
                case "dateRange":
                    initialValue.dateFrom = (_b = filterConfig.initialValue) === null || _b === void 0 ? void 0 : _b.dateFrom;
                    initialValue.dateTo = (_c = filterConfig.initialValue) === null || _c === void 0 ? void 0 : _c.dateTo;
                    break;
                case "number":
                case "text":
                default:
                    initialValue.value = (_d = filterConfig.initialValue) === null || _d === void 0 ? void 0 : _d.value;
                    break;
            }
            return __assign({ field: filterConfig.field, parentRelationField: filterConfig.parentRelationField, type: filterConfig.type }, filterConfig.initialValue);
        }) || []);
    };
    var _g = useState(getInitialFilterParams()), filterParams = _g[0], setFilterParams = _g[1];
    useEffect(function () {
        fetchRowData();
        // eslint-disable-next-line
    }, []);
    useEffect(function () {
        fetchRowData();
        // eslint-disable-next-line
    }, [page, pageSize, sortField, sortDirection]);
    useEffect(function () {
        setPage(1);
        fetchRowData(1);
        // eslint-disable-next-line
    }, [filterParams]);
    var fetchRowData = function (pageOverride) { return __awaiter(void 0, void 0, void 0, function () {
        var fetchParams, data, items, i;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    fetchParams = {
                        page: pageOverride || page,
                        count: pageSize,
                    };
                    if (sortField) {
                        fetchParams.orderBy = { field: sortField, direction: sortDirection };
                    }
                    if (filterParams) {
                        fetchParams.filters = filterParams;
                    }
                    return [4 /*yield*/, props.dataFetch(fetchParams)];
                case 1:
                    data = _a.sent();
                    if (data) {
                        items = data.rowData;
                        if (items.length < pageSize) {
                            for (i = pageSize - items.length; i > 0; i--) {
                                items.push({
                                    id: "empty-row-".concat(i),
                                });
                            }
                        }
                        setRowData(data.rowData);
                        setRowCount(data.rowCount);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var columnRender = function (config, rowItem) {
        var value = rowItem.id.includes("empty-row")
            ? "empty"
            : config.valueParser
                ? config.valueParser(rowItem)
                : config.parentRelationField
                    ? rowItem[config.parentRelationField][config.field]
                    : rowItem[config.field];
        return config.cellRenderer && value !== "empty" ? (config.cellRenderer(rowItem)) : (_jsx("div", { children: value || undefined }));
    };
    var resetSortsAndFilters = function () {
        setSortDirection("DESC");
        setSortField(undefined);
        setFilterParams(getInitialFilterParams());
    };
    var headerColor = props.headerColor
        ? "rgb(".concat(props.headerColor.r, ", ").concat(props.headerColor.g, ", ").concat(props.headerColor.b, ") !important")
        : undefined;
    return (_jsxs(Table, __assign({ highlightOnHover: true, sx: [
            {
                table: {
                    borderCollapse: "separate",
                    borderSpacing: 0,
                },
                height: props.maxHeight || 400,
                thead: {
                    position: "sticky",
                    top: 0,
                    backgroundColor: props.headerBg || "".concat(theme.colors.gray[1]),
                    "&:before": {
                        content: '""',
                        position: "absolute",
                        left: 0,
                        width: "100%",
                        top: 0,
                        borderTop: "1px solid ".concat(props.borderColor || theme.colors.gray[4]),
                    },
                    "&:after": {
                        content: '""',
                        position: "absolute",
                        left: 0,
                        width: "100%",
                        bottom: 0,
                        borderBottom: "1px solid ".concat(props.borderColor || theme.colors.gray[4]),
                    },
                    th: {
                        borderRight: "1px solid ".concat(props.borderColor || theme.colors.gray[4]),
                        "&:first-of-type": {
                            borderLeft: "1px solid ".concat(props.borderColor || theme.colors.gray[4]),
                        },
                        padding: "10px 10px !important",
                    },
                },
                tbody: {
                    flexDirection: "column",
                    height: props.maxHeight || 400,
                    td: {
                        "&:first-of-type": {
                            borderLeft: "1px solid ".concat(props.borderColor || theme.colors.gray[4]),
                        },
                        "&:not(last-of-type)": {
                            borderBottomColor: props.borderColor,
                        },
                        borderRight: "1px solid ".concat(props.borderColor || theme.colors.gray[4]),
                    },
                },
                tfoot: {
                    backgroundColor: "".concat(props.headerBg || theme.colors.gray[1]),
                    position: "sticky",
                    bottom: 0,
                    "&:before": {
                        content: '""',
                        position: "absolute",
                        left: 0,
                        width: "100%",
                        top: 0,
                        borderTop: "1px solid ".concat(props.borderColor || theme.colors.gray[4]),
                    },
                    "&:after": {
                        content: '""',
                        position: "absolute",
                        left: 0,
                        width: "100%",
                        bottom: 0,
                        borderBottom: "1px solid ".concat(props.borderColor || theme.colors.gray[4]),
                    },
                    td: {
                        borderRight: "1px solid ".concat(props.borderColor || theme.colors.gray[4]),
                        "&:first-of-type": {
                            borderLeft: "1px solid ".concat(props.borderColor || theme.colors.gray[4]),
                        },
                        padding: "5px 10px !important",
                    },
                },
            },
            props.tableSx,
        ] }, { children: [_jsx("thead", { children: _jsx("tr", { children: props.columnConfigs.map(function (colConfig, index) { return (_jsx("th", { children: _jsxs(Group, __assign({ position: "apart" }, { children: [_jsx(Text, __assign({ style: { color: headerColor } }, { children: colConfig.name })), _jsxs(Group, __assign({ spacing: "xs" }, { children: [colConfig.sortable && (_jsx(ActionIcon, __assign({ size: "sm", variant: "subtle", color: "gray", sx: {
                                                color: headerColor,
                                                "&:hover": {
                                                    color: props.headerBg,
                                                    backgroundColor: props.headerColor
                                                        ? "rgba(".concat(props.headerColor.r, ", ").concat(props.headerColor.g, ", ").concat(props.headerColor.b, ", 0.75) !important")
                                                        : undefined,
                                                },
                                            }, onClick: sortField === colConfig.field
                                                ? function () {
                                                    if (sortDirection === "ASC") {
                                                        setSortDirection("DESC");
                                                    }
                                                    else {
                                                        setSortField(undefined);
                                                    }
                                                }
                                                : function () {
                                                    setSortField(colConfig.field);
                                                    setSortDirection("ASC");
                                                } }, { children: sortField === colConfig.field ? (sortDirection === "ASC" ? (_jsx(TbSortAscending2, { size: 20, color: "tomato" })) : (_jsx(TbSortDescending2, { size: 20, color: "tomato" }))) : (_jsx(TbArrowsSort, { size: 20 })) }))), colConfig.filter && (_jsx(TableFilter, { headerBg: props.headerBg, headerColor: props.headerColor, currentParam: filterParams.find(function (param) { var _a; return param.field === ((_a = colConfig.filter) === null || _a === void 0 ? void 0 : _a.field); }), filterConfig: colConfig.filter, onClearFilter: function (field) {
                                                setFilterParams(function (old) {
                                                    return old.filter(function (param) { return param.field !== field; });
                                                });
                                            }, onChangeFilter: function (filterBy) {
                                                setFilterParams(function (old) {
                                                    var exists = old.find(function (param) { return param.field === filterBy.field; });
                                                    if (!exists) {
                                                        return __spreadArray(__spreadArray([], old, true), [filterBy], false);
                                                    }
                                                    else {
                                                        return __spreadArray(__spreadArray([], old.filter(function (param) { return param.field !== filterBy.field; }), true), [
                                                            filterBy,
                                                        ], false);
                                                    }
                                                });
                                            } }))] }))] })) }, colConfig.name + index)); }) }) }), _jsx("tbody", { children: rowData.map(function (rowItem) { return (_jsx("tr", __assign({ style: rowItem.id.includes("empty-row")
                        ? { opacity: 0, pointerEvents: "none" }
                        : {} }, { children: props.columnConfigs.map(function (colConfig) { return (_jsx("td", { children: columnRender(colConfig, rowItem) }, rowItem.id + colConfig.name)); }) }), rowItem.id)); }) }), _jsx("tfoot", { children: _jsx("tr", { children: _jsx("td", __assign({ colSpan: 100 }, { children: _jsxs("div", __assign({ style: {
                                flex: 1,
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center"
                            } }, { children: [_jsx("div", __assign({ style: { marginLeft: props.columnConfigs.some(function (x) { return x.filter || x.sortable; }) ? 'auto' : 0 } }, { children: _jsx(PaginationBar, { page: page, pageSize: pageSize, setPage: setPage, setPageSize: setPageSize, totalRowItems: rowCount }) })), props.columnConfigs.some(function (x) { return x.filter || x.sortable; }) && (_jsx("div", __assign({ style: { marginLeft: 'auto' } }, { children: _jsx(Button, __assign({ size: "xs", color: "gray", onClick: resetSortsAndFilters }, { children: "Reset" })) })))] })) })) }) })] })));
};
export default KapexTable;
